import { AddRiwayatPendidikanPayload } from "../../../../models/RiwayatPendidikan";
import { getApiInstance } from "../../../api";
import mutationWrapper from "../../mutationWrapper";
import { allRiwayatPendidikanKey } from "../../queries/RiwayatPendidikan/useFetchAllRiwayatPendidikan";
import { checkProfileKey } from "../../queries/User/useFetchCheckProfile";
import getQueryClient from "../../queryClient";
import ApiClient from "../../../apiClient";

export async function addRiwayatPendidikan(data: AddRiwayatPendidikanPayload) {
  const res = await ApiClient.post(`/AddPendidikan`, data);
  return res.data;
}

export const useAddRiwayatPendidikan = mutationWrapper(addRiwayatPendidikan, {
  onSuccess: () => {
    getQueryClient().invalidateQueries(allRiwayatPendidikanKey);
    getQueryClient().invalidateQueries(checkProfileKey);
  },
});
